module.exports = __webpack_public_path__ + "img/img_test_510.42976cdd.png";